import { Location } from '#/global/helper/Location'

export const getPageType = () => {
    const path = window.location.pathname
    switch (true) {
        case path.includes('/produkty') || path.includes('/pujcovna/detail'):
            return 'product'
        case path.includes('/vypis') || path.includes('/pujcovna/vypis'):
            return 'category'
        case path.includes('/sekce'):
            return 'category'
        case path.includes('/search'):
            return 'search'
        case path.includes('/kosik/krok'):
            return 'cart'
        case path.includes('/kosik'):
            return 'share-cart'
        case Location.getUrlWithoutBranch() === '/':
            return 'homepage'
        case true:
            return 'unknown'
    }
}
